import ApiManager from '@/utils/ApiManager'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'
import Vue from 'vue'

const state = {
  categoryName: 'アカウント',
  
  // model
  userModel: [],
  serviceModel: [],

  // 検索
  filters: {
    searchUserName: null,
    searchMailAddress: null,
    searchUserType: '',
    searchService: '',
    searchStatus: '',
  }
}

const getters = {
  get: state => state
}

const actions = {
  /**
   * 初期データを読出し
   */
  loadModel ({commit}, {userParams, serviceParams}) {
    return new Promise((resolve, reject) => {
      const isAdmin = this.getters['auth/isAdmin']

      const types = ['user']
      const methods = ['v1UserListGet']
      const parameters = [userParams]

      // システム管理者の場合
      if (isAdmin) {
        types.push('service')
        methods.push('v1ServiceListGet')
        parameters.push(serviceParams)
      }

      ApiManager.request(types, methods, parameters)
        .then(res => {
          let status = Utility.parseResponse(res)

          if (status.result) {
            commit('setUserModel', res[0].data.users)
            console.log('userModel', state.userModel)
            if (isAdmin) {
              commit('setServiceModel', res[1].data.serviceInfo)
              console.log('serviceModel', state.serviceModel)
            }
            resolve()

          } else if (status.error) {
            // エラーメッセージ表示
            reject(res)
          } else {
            // アプリケーションエラー表示
            reject(null)
          }
        })
        .catch(error => {
          // アプリケーションエラー表示
          reject(null)
        })
    })
  },
  /**
   * アカウント一覧を読出し
   */
  loadUserList ({commit}, {userParams}) {
    return new Promise((resolve, reject) => {
      ApiManager.request(
        ['user'],
        ['v1UserListGet'],
        [userParams])
        .then(res => {
          let status = Utility.parseResponse(res)

          if (status.result) {
            commit('setUserModel', res[0].data.users)
            console.log('userModel', state.userModel)
            resolve()

          } else if (status.error) {
            // エラーメッセージ表示
            reject(res)
          } else {
            // アプリケーションエラー表示
            reject(null)
          }
        })
        .catch(error => {
          // アプリケーションエラー表示
          reject(null)
        })
    })
  },
  reset({commit}) {
    commit('resetState')
  }
}

const mutations = {
  // model
  setUserModel (state, data) {
    // data.sort(Utility.sortByKey('CreatedAt', false))
    Vue.set(state, 'userModel', data)
  },
  setServiceModel (state, data) {
    // data.sort(Utility.sortByKey('CreatedAt', false))
    Vue.set(state, 'serviceModel', data)
  },

  setInputFilter (state, {key, value}) {
    Vue.set(state.filters, key, value)
  },

  resetState (state) {
    Vue.set(state, 'userModel', [])
    Vue.set(state, 'serviceModel', [])

    state.filters.searchUserName = null
    state.filters.searchMailAddress = null
    state.filters.searchUserType = ''
    state.filters.searchService = ''
    state.filters.searchStatus = ''
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
